/* global swal google */
import './style.less';

import moment from 'moment-timezone';

export default function($log, $stateParams) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const profile_uid = $stateParams.employeeID || $stateParams.id;

  function activate() {
    $log.debug('Users Profile Controller Activated');

    vm.profile_uid = profile_uid;
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/profile/index.js